// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var DocumentID = function (x) {
    return x;
};
var tsBridgeDocumentID = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("DocumentID")("__brandDocumentID"));
    }
};
var writeDocumentID = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showDocumentID = Data_Show.showString;
var readDocumentID = Simple_JSON.readString;
var ordDocumentID = Data_Ord.ordString;
var newtypeDocumentID = {
    Coercible0: function () {
        return undefined;
    }
};
var makeDocumentID = DocumentID;
var eqDocumentID = Data_Eq.eqString;
export {
    DocumentID,
    makeDocumentID,
    unwrap,
    newtypeDocumentID,
    eqDocumentID,
    ordDocumentID,
    showDocumentID,
    readDocumentID,
    writeDocumentID,
    tsBridgeDocumentID
};
//# sourceMappingURL=index.js.map
